<template>
    <div class="search--container" :style="containerStyle">
        <md-field md-clearable @md-clear="handleClear" :style="fieldStyle">
            <md-input type="text" :placeholder="placeholder" v-model="searchText" @keyup.enter="handleSearch" />
        </md-field>
        <div class="search-button--container" v-if="searchIcon">
            <md-button class="md-icon-button md-dense md-raised md-primary" @click="handleSearch">
                <md-icon>search</md-icon>
            </md-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchComponent',
    props: {
        handleSearchOnType: { type: Boolean, default: false },
        placeholder: { type: String, default: 'Search' },
        searchIcon: { type: Boolean, default: true },
        searchFilter: { type: String, default: null },
        minWidth: { type: Number, default: 140 }, // base min width
        charWidth: { type: Number, default: 7 }, // approximate avg char width in px
        paddingExtra: { type: Number, default: 55 } // extra space for clear icon & padding
    },
    data() {
        return { searchText: '' };
    },
    mounted() {
        this.searchText = this.searchFilter;
    },
    watch: {
        searchText(newVal) {
            if (this.handleSearchOnType) 
                this.$emit('onSearch', { searchText: newVal });
        },
        searchFilter() {
            this.searchText = this.searchFilter;
        }
    },
    computed: {
        dynamicWidth() {
            const length = this.placeholder?.length || 0;
            const calc = length * this.charWidth + this.paddingExtra;
            return Math.max(this.minWidth, calc);
        },
        fieldStyle() {
            return { width: `${this.dynamicWidth}px` };
        },
        containerStyle() {
            return { width: `${this.dynamicWidth + (this.searchIcon ? 50 : 0)}px` };
        }
    },
    methods: {
        handleClear() {
            this.searchText = '';
            this.handleSearch();
        },
        handleSearch() {
            this.$emit('onSearch', { searchText: this.searchText });
        }
    }
};
</script>

<style lang="scss" scoped>
.search--container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    transition: width 0.2s ease;

    ::v-deep .md-field {
        box-sizing: border-box;
        margin-top: 0;
        transition: width 0.2s ease;
        &::before,
        &::after {
            bottom: 10px;
        }
    }
    .search-button--container {
        margin-right: 12px;
        margin-left: 4px;
        display: inline-block;
    }
}
</style>
